import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class BlogService {
  getBlogList() {
    return axios.get(API_URL + '/blog/published')
  }
  getBlogInformation(Id){
    return axios.get(API_URL + '/blog/' + Id)
  }
}

export default new BlogService()
